module.exports = __webpack_public_path__ + "img/flot5.c73cd7c0.svg";